export const triggerDownload = async (
  url: string,
  filename: string,
  blob?: Blob,
): Promise<void> => {
  const anchor = document.createElement("a");
  const href = blob ? URL.createObjectURL(blob) : url;
  anchor.href = href;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  if (blob) setTimeout(() => URL.revokeObjectURL(href), 10000);
};
